/**
 * =============================================================================
 * geo-detect.js 
 * =============================================================================
 * Get geographic data about the user using Geoapify
 * =============================================================================
 */

var GeoDetect = {

  // Geoapify API key - same for all stores
  api_key: "ac7aea69520b4ed3900cd917d0162038",

  onReady: function(){
    this.getUserGeoData().then(function(result) {
      let geodataJSON = JSON.parse(result)

      console.log("[G-D]", geodataJSON);

      if(geodataJSON.error){
        console.log("[G-D] Error getting location");
        return;
      }

      // Dispatch a CustomEvent for other extensions to listen for / react to
      let event = new CustomEvent("geodata:loaded", {
        detail: {
          data: geodataJSON
        }
      });
      document.dispatchEvent(event);
    });
  },

  /**
   * Get either cached or fresh geolocation data. If not cached, store as cookie
   * 
   * @returns {Promise} a Promise
   */
  getUserGeoData: function() {
    let developmentIsoCode = window?.debug.developmentIsoCode || "GB";

    if(window.theme.isDevelopment) {
      console.log("[G-D] Using development iso code...");
      let stubbedGeoData = JSON.stringify({ country: { iso_code: developmentIsoCode } });
      console.log("[G-D] Stubbed data in development", stubbedGeoData);
      return Promise.resolve(stubbedGeoData);
    } else if(Cookies.get('mp-geo') === undefined) {
      console.log("[G-D] Fetching fresh...");
      return this.fetchUserGeoData();
    } else {
      console.log("[G-D] Using cookie...");
      return Promise.resolve(Cookies.get("mp-geo"));
    }
  },

  /**
   * Get the current user's geographic data from their IP via Geoapify
   * 
   * @returns {Promise} a Promise
   */
  fetchUserGeoData: function() {
    let requestOptions = {
      method: 'GET',
    };
    
    return fetch("https://api.geoapify.com/v1/ipinfo?&apiKey=" + this.api_key, requestOptions)
      .then(function(response) {
        return response.json();
      })
      .then(function(result) {
        //console.log("[G-D] Got data from Geoapify - setting as cookie and returning");
        Cookies.set("mp-geo", JSON.stringify(result));
        return JSON.stringify(result);
      })
      .catch(function(error) {
        console.log('[G-D] Error fetching geo data', error);
      });
  },

  /**
   * Get the current user's geographic data from Shopify (country only)
   * 
   * @returns {Promise} a Promise
   */
  fetchUserGeoDataFromShopify: function() {
    return fetch(window.routes.browsing_context_suggestions_url)
      .then(res => res.json())
      .then(result => {
        console.log("[G-D] Result from Shopify", result);
        let data = JSON.stringify({ country: { iso_code: result.detected_values.country.handle } });
        Cookies.set("mp-geo", data);
        return data;
      })
      .catch(function(error) {
        console.log('[G-D] Error fetching geodata from Shopify', error);
      });
  }
};

export default GeoDetect;